module.exports = __webpack_public_path__ + "67700b6bb5be7e83a432224bcd16a4a0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-2.png
// module id = 2223
// module chunks = 0